import { ContentDataSchema } from "../../../apis/stateful-content";

export interface TrainingItem extends Record<string, any> {
    title?: string;
    id: number;
    category: number | string;
    typeId: number;
    levels: string[];
    languages: string[];
    description: string;
    events: TrainingEvent[];
}

export interface TrainingEvent {
    startDate: string;
    languages: string[];
    duration: string;
    location: string;
    availability: number;
    detailsLink: string;
}

export interface TrainingGroup {
    label?: string;
    category: number | string;
    items: TrainingItem[];
}

export interface TrainingSchema extends ContentDataSchema {
    category: {
        order: Array<number | string>;
    };
}
